// App.jsx
import { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

// 布局组件
import Layout from "./components/Layout_component";

// 核心页面（首屏需要，不懒加载）
import Home from "./components/Home_component";

import Write from "./components/Write_component";
import Check from "./components/Check_component";
import Aiwrite from "./components/Aiwrite_component";
import Ainav from "./components/Ainav_component";
import Searchnav from "./components/Searchnav_component";
import Todoist from "./components/Todoist_component";
// 懒加载其他页面

const Figures = lazy(() => import("./components/Figures_component"));
const Wordphoto = lazy(() => import("./components/Wordphoto_component"));

const Book = lazy(() => import("./components/Book_component"));
const Draw = lazy(() => import("./components/Draw_component"));
const Xmind = lazy(() => import("./components/Xmind_component"));
const ThreeD = lazy(() => import("./components/ThreeD_component"));
const ThreeDViewer = lazy(() => import("./components/ThreeDViewer_component"));
const Intelligent_attachment = lazy(
  () => import("./components/Intelligent_attachment_component"),
);

// 加载骨架屏组件
const LoadingFallback = () => (
  <div
    style={{ height: "100vh" }}
    className="loading-container"
    role="status"
    aria-live="polite"
  >
    <div className="loading-spinner"></div>
    <p className="text-center">页面加载中...</p>
    {/* 旋转器 */}
    <div className="d-flex justify-content-center align-items-center">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
);

function App() {
  return (
    <HelmetProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            <Route path="/" element={<Layout />}>
              {/* 首页 */}
              <Route index element={<Home />} />

              {/* 工具类页面 */}
              <Route path="todolist" element={<Todoist />} />
              <Route path="write" element={<Write />} />
              <Route path="aiwrite" element={<Aiwrite />} />
              <Route path="figures" element={<Figures />} />
              <Route path="draw" element={<Draw />} />
              <Route path="xmind" element={<Xmind />} />
              <Route path="extract_word_photo" element={<Wordphoto />} />
              <Route path="check" element={<Check />} />
              <Route
                path="Intelligent_attachment_component"
                element={<Intelligent_attachment />}
              />

              {/* 资源类页面 */}
              <Route path="book" element={<Book />} />

              {/* 导航类页面 */}
              <Route path="searchnav" element={<Searchnav />} />
              <Route path="ainav" element={<Ainav />} />

              {/* 3D相关页面 */}
              <Route path="ThreeD" element={<ThreeD />} />
              <Route path="threeDViewer" element={<ThreeDViewer />} />

              {/* 其他页面 */}
              <Route
                path="intelligent_attachment"
                element={<Intelligent_attachment />}
              />

              <Route path="*" element={<Home />} />
            </Route>
          </Routes>
        </Suspense>
      </Router>
    </HelmetProvider>
  );
}

export default App;
